<template>
  <nav aria-label="breadcrumbs" class="breadcrumb" v-if="breadcrumbs.length > 0">
    <ol class="flex align-items-center items-center">
      <li
        class="flex align-items-center items-center"
        :key="`breadcrumb_item_${ind}`"
        v-for="(bc, ind) in breadcrumbs"
      >
        <span aria-current="location" class="active" v-if="bc.status === 'active'">{{
          bc.title
        }}</span>
        <template v-else>
          <span :key="`breadcrumb_item_${ind}`"
            ><router-link :to="bc.url">{{ bc.title }}</router-link></span
          >
          <feather-icon
            aria-hidden="true"
            :key="`breadcrumb_icon_${ind}`"
            icon="ChevronsRightIcon"
            svgClasses="h-4 w-4"
            class="mx-3"
          />
        </template>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  // The trail was a single non-wrapping flex row, so at high zoom it pushed the page wider
  // than the viewport and forced horizontal scrolling (WCAG SC 1.4.10 Reflow). Allowing it
  // to wrap keeps everything within the viewport at 400%.
  ol {
    flex-wrap: wrap;
  }

  li {
    max-width: 100%;
  }

  span {
    &.active {
      color: rgba(0, 0, 0, 0.8);
      font-size: 12px;
    }

    & > a {
      text-decoration: none;
      border: 1px solid transparent;
      box-sizing: border-box;
      color: rgba(0, 0, 0, 0.8);
      font-size: 12px;

      &:not(.active):hover {
        text-decoration: underline;
      }

      &:focus {
        border: 1px solid #2462d2;
      }
    }
  }
}
</style>
